import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BlobStorageFacade 
{
  private _urlBase: string
  private _httpClient: HttpClient;

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) 
  { 
    this._urlBase = baseUrl;
    this._httpClient = http;
  }

  GetThumbnailByActivStoreInstId(activStoreInstId: number): Observable<any> {
      return this._httpClient.get<any>(this._urlBase + 'api/BlobStorage/Thumbnail?activStoreInstId='+ activStoreInstId)
  }

  GetBlob(idStore: number, blobStorId: number): Observable<any> {
    // tslint:disable-next-line: max-line-length
    return this._httpClient.get<any>(this._urlBase + 'api/BlobStorage/file?storeId=' + idStore + '&blobStorId=' + blobStorId + '&onlyThumbnail=false&onlyBase64=true');
  }

  GetBlobByOrganizationModule(organizationId: string, catDetMobileModuleId: number): Observable<any> {
    // tslint:disable-next-line: max-line-length
    return this._httpClient.get<any>(this._urlBase + 'api/BlobStorage/file?organizationId=' + organizationId + '&catDetMobileModuleId=' + catDetMobileModuleId + '&onlyThumbnail=false&onlyBase64=true');
  }

  UploadStorePlane(blob : any): Observable<any> {
    let body = JSON.stringify(blob)
    
    return this._httpClient.post(this._urlBase + 'api/BlobStorage/uploadStorePlane', body, { 
      headers: new HttpHeaders({'Content-Type':  'application/json'})
    })
  }
}
